import { ChangeDetectorRef, Component, OnInit } from "@angular/core";
import { TranslateService } from "@ngx-translate/core";
import { NgxSpinnerService } from "ngx-spinner";
import { HttpHelpService } from "../../service/http-help.service";
import { ActivatedRoute } from "@angular/router";
import { FormControl, FormGroup, Validators } from "@angular/forms";
import { NgbModal } from "@ng-bootstrap/ng-bootstrap";
import Swal from "sweetalert2";

@Component({
  selector: "app-update-company",
  templateUrl: "./update-company.component.html",
  styleUrls: ["./update-company.component.scss", "../company.component.scss"],
})
export class UpdateCompanyComponent implements OnInit {
  curentLang: string = "";
  layoutVersion: any;
  userRegistId: any = JSON.parse(localStorage.getItem("user_id"));
  merchantId = JSON.parse(localStorage.getItem("merchant_id"));
  user_type = JSON.parse(localStorage.getItem("user_type"));

  companyInfoData: any = [];
  id: number;
  uuid: string;
  companyNameAr: string = "";
  companyNameEn: string = "";
  companyNamehE: string = "";
  logoUrl: string = "";
  TaxRegister: string = "";
  CommercialRegister: string = "";
  startInvoiceNumber: string = "";
  VatListId: number;
  VATNameAR: string = "";
  VATNameEN: string = "";
  VATNameHE: string = "";
  CompanyAddressSTR: string = "";
  CompanyAddressSTRAr: string = "";
  CompanyAddressSTREn: string = "";
  CompanyBuildingNumber: string = "";
  CompanyAddressCity: string = "";
  CompanyAddressCityAr: string = "";
  CompanyAddressCityEn: string = "";
  CompanyAddressZipCode: string = "";
  CompanyId: number;
  companyPhone: any;
  templates: any[] = [];

  public file: any;
  url: any;
  files: File[] = [];
  currentImageUrl: any;
  updateCompanyInfo: FormGroup;
  leftNote: string = '';
  rightNote: string = '';
  updateCompanyInfoByAdmin: FormGroup;
  vatInfoData: any = [];
  companyTypeData: any = [];
  companyTypeLoading: boolean = false;
  public validate = false;
  /** Bootstrap-style validation display for merchant edit form (mirrors add-company). */
  validateMerchant = false;

  /** Same UX as add-company: optional AR/EN translation blocks. */
  translationAddon: { ar: boolean; en: boolean } = { ar: false, en: false };
  translationPickerOpen = false;

  newOrders = {
    colorClass: "primary",
    icon: "new-order",
    colorClass2: "warning",
    icon2: "customers",
    colorClass3: "success",
    icon4: "invoice",
    colorClass4: "secondary",
    icon3: "profit",
  };

  uploadImage = new FormGroup({
    file: new FormControl(""),
    id: new FormControl(""),
  });

  constructor(
    private spinner: NgxSpinnerService,
    public translate: TranslateService,
    private service: HttpHelpService,
    private activatedRoute: ActivatedRoute,
    private modalService: NgbModal,
    private cdRef: ChangeDetectorRef
  ) {
    this.curentLang = localStorage.getItem("curentLang");
    this.uuid = this.activatedRoute.snapshot.params["id"];

    this.updateCompanyInfo = new FormGroup({
      company_name_ar: new FormControl(""),
      company_name_en: new FormControl(""),
      company_name_he: new FormControl("", Validators.required),
      company_address_str: new FormControl("", Validators.required),
      company_address_str_ar: new FormControl(""),
      company_address_str_en: new FormControl(""),
      company_Building_number: new FormControl("", Validators.required),
      company_phone: new FormControl(""),
      company_address_city: new FormControl("", Validators.required),
      company_address_city_ar: new FormControl(""),
      template_id: new FormControl(""), // Add this here
      template_url: new FormControl(""), // Add this here
      left_note: new FormControl("", [Validators.maxLength(200)]),
      right_note: new FormControl("", [Validators.maxLength(200)]),
      company_address_city_en: new FormControl(""),
      company_address_zip_code: new FormControl(""),
      company_type_id: new FormControl("", Validators.required),
      updated_by: new FormControl(this.userRegistId),
    });

    this.updateCompanyInfoByAdmin = new FormGroup({
      tax_register: new FormControl("", [
        Validators.required,
        Validators.pattern("^[0-9]{9}$"),
      ]),
      commercial_register: new FormControl("", [
        Validators.required,
        Validators.pattern("^[0-9]"),
      ]),
      company_name_ar: new FormControl(""),
      company_name_en: new FormControl(""),
      company_phone: new FormControl(""),
      company_name_he: new FormControl("", Validators.required),
      company_address_str: new FormControl("", Validators.required),
      company_address_str_ar: new FormControl("", Validators.required),
      company_address_str_en: new FormControl("", Validators.required),
      company_Building_number: new FormControl("", Validators.required),
      company_address_city: new FormControl("", Validators.required),
      company_address_city_ar: new FormControl(""),
      company_address_city_en: new FormControl(""),
      company_address_zip_code: new FormControl("", Validators.required),
      template_id: new FormControl(""), // Add this here
      template_url: new FormControl(""), // Add this here
      company_type_id: new FormControl("", Validators.required),

      updated_by: new FormControl(this.userRegistId),
    });
  }

  openVerticallyCentered(dataDeleted: any) {
    this.modalService.open(dataDeleted, { centered: true });
  }
  openTemplateModal(templateModal: any) {
    this.modalService.open(templateModal, { centered: true, size: "lg" });
  }

  toggleTranslationPicker(): void {
    this.translationPickerOpen = !this.translationPickerOpen;
  }

  addTranslationLang(code: "ar" | "en"): void {
    if (code === "ar") this.translationAddon.ar = true;
    else this.translationAddon.en = true;
    this.translationPickerOpen = false;
  }

  removeTranslationLang(code: "ar" | "en"): void {
    if (code === "ar") {
      this.translationAddon.ar = false;
      this.updateCompanyInfo.patchValue({
        company_name_ar: "",
        company_address_city_ar: "",
        company_address_str_ar: "",
      });
      this.updateCompanyInfoByAdmin.patchValue({
        company_name_ar: "",
        company_address_city_ar: "",
        company_address_str_ar: "",
      });
      this.companyNameAr = "";
      this.CompanyAddressCityAr = "";
      this.CompanyAddressSTRAr = "";
    } else {
      this.translationAddon.en = false;
      this.updateCompanyInfo.patchValue({
        company_name_en: "",
        company_address_city_en: "",
        company_address_str_en: "",
      });
      this.updateCompanyInfoByAdmin.patchValue({
        company_name_en: "",
        company_address_city_en: "",
        company_address_str_en: "",
      });
      this.companyNameEn = "";
      this.CompanyAddressCityEn = "";
      this.CompanyAddressSTREn = "";
    }
  }

  get showAddTranslationButton(): boolean {
    return !this.translationAddon.ar || !this.translationAddon.en;
  }

  private syncTranslationAddonFromCompany(res: any): void {
    const hasAr =
      !!(res?.company_name_ar && String(res.company_name_ar).trim()) ||
      !!(res?.company_address_city_ar && String(res.company_address_city_ar).trim()) ||
      !!(res?.company_address_str_ar && String(res.company_address_str_ar).trim());
    const hasEn =
      !!(res?.company_name_en && String(res.company_name_en).trim()) ||
      !!(res?.company_address_city_en && String(res.company_address_city_en).trim()) ||
      !!(res?.company_address_str_en && String(res.company_address_str_en).trim());
    this.translationAddon = { ar: hasAr, en: hasEn };
    this.translationPickerOpen = false;
  }
  deleteCompanyLogoByCompanyId() {
    this.spinner.show();
    this.service.deleteCompanyLogoByCompanyId(this.CompanyId).subscribe({
      next: (res) => {
        if (
          res.statusCode == 400 ||
          res.statusCode == 500 ||
          res.statusCode == 404
        ) {
          Swal.fire({
            icon: "error",
            title:
              this.curentLang === "ar"
                ? res.messageAr
                : this.curentLang === "en"
                ? res.messageEn
                : res.messageHe,
          });
          this.spinner.hide();
          return;
        } else {
          Swal.fire({
            icon: "success",
            title:
              this.curentLang === "ar"
                ? res.messageAr
                : this.curentLang === "en"
                ? res.messageEn
                : res.messageHe,
          });
          this.getCompanyInfoById();
          this.modalService.dismissAll();
          this.spinner.hide();
        }
      },
      error: (err) => {
        Swal.fire(err.messageAr);
        this.spinner.hide();
      },
    });
  }

  getCompanyInfoById(): Promise<void> {
    this.spinner.show();
    return new Promise((resolve, reject) => {
      this.service.getCompanyInfoById(this.id).subscribe({
        next: (res) => {
          this.companyInfoData = res;
  
          this.companyPhone = res?.company_phone;
          this.companyNameAr = res?.company_name_ar;
          this.companyNameEn = res?.company_name_en;
          this.companyNamehE = res?.company_name_he;
          this.logoUrl = res?.logo_url;
          this.CompanyId = res?.company_id;
          this.TaxRegister = res?.tax_register;
          this.CommercialRegister = res?.commercial_register;
          this.startInvoiceNumber = res?.start_invoice_number;
          this.VatListId = res?.vat_list_id;
          this.VATNameAR = res?.vatList?.vat_name_ar;
          this.VATNameEN = res?.vatList?.vat_name_en;
          this.VATNameHE = res?.vatList?.vat_name_he;
          this.CompanyAddressSTR = res?.company_address_str;
          this.CompanyAddressSTRAr = res?.company_address_str_ar;
          this.CompanyAddressSTREn = res?.company_address_str_en;
          this.CompanyAddressCity = res?.company_address_city;
          this.CompanyAddressCityAr = res?.company_address_city_ar;
          this.CompanyAddressCityEn = res?.company_address_city_en;
          this.CompanyAddressZipCode = res?.company_address_zip_code;
          this.CompanyBuildingNumber = res?.company_Building_number;
  
          // ✅ Convert any <br>-style tags back to \n for textarea input
          // Handles: <br>, <br/>, <br />, <BR>, etc.
          this.leftNote = res?.left_note
            ? res.left_note.replace(/<br\s*\/?>/gi, '\n')
            : '';
          this.rightNote = res?.right_note
            ? res.right_note.replace(/<br\s*\/?>/gi, '\n')
            : '';

          // ✅ Keep reactive form controls in sync with the component properties
          this.updateCompanyInfo.patchValue({
            company_name_ar: res?.company_name_ar ?? "",
            company_name_en: res?.company_name_en ?? "",
            company_name_he: res?.company_name_he ?? "",
            company_address_str: res?.company_address_str ?? "",
            company_address_str_ar: res?.company_address_str_ar ?? "",
            company_address_str_en: res?.company_address_str_en ?? "",
            company_Building_number: res?.company_Building_number ?? "",
            company_phone: res?.company_phone ?? "",
            company_address_city: res?.company_address_city ?? "",
            company_address_city_ar: res?.company_address_city_ar ?? "",
            company_address_city_en: res?.company_address_city_en ?? "",
            company_address_zip_code: res?.company_address_zip_code ?? "",
            left_note: this.leftNote,
            right_note: this.rightNote,
          });

          this.updateCompanyInfoByAdmin.patchValue({
            company_name_ar: res?.company_name_ar ?? "",
            company_name_en: res?.company_name_en ?? "",
            company_name_he: res?.company_name_he ?? "",
            company_address_str: res?.company_address_str ?? "",
            company_address_str_ar: res?.company_address_str_ar ?? "",
            company_address_str_en: res?.company_address_str_en ?? "",
            company_Building_number: res?.company_Building_number ?? "",
            company_phone: res?.company_phone ?? "",
            company_address_city: res?.company_address_city ?? "",
            company_address_city_ar: res?.company_address_city_ar ?? "",
            company_address_city_en: res?.company_address_city_en ?? "",
            company_address_zip_code: res?.company_address_zip_code ?? "",
            tax_register: res?.tax_register ?? "",
            commercial_register: res?.commercial_register ?? "",
          });

          this.syncTranslationAddonFromCompany(res);
  
          // ✅ Ensure the template_id is set correctly in the form
          if (res?.template_id) {
            this.updateCompanyInfo.patchValue({ template_id: res.template_id });
            this.updateCompanyInfoByAdmin.patchValue({
              template_id: res.template_id,
            });
          }

          // Note: Company type will be set after company type data is loaded
          // This is handled in setPreselectedCompanyType() method
  
          this.spinner.hide();
          resolve();
        },
        error: (error) => {
          this.spinner.hide();
          reject(error);
        },
      });
    });
  }

  getCompanyIdByUuid(): Promise<void> {
    return new Promise((resolve, reject) => {
      this.service.getCompanyIdByUuid(this.uuid).subscribe({
        next: (res) => {
          this.id = res?.company_id;
          this.getCompanyInfoById().then(resolve).catch(reject); // Ensure company data is loaded
        },
        error: (error) => {
          Swal.fire({
            icon: "error",
            title:
              this.curentLang === "ar"
                ? "فشل في الحصول على معلومات المصلحة التجارية"
                : this.curentLang === "en"
                ? "Failed to get company information"
                : "נכשל בהשגת מידע על החברה",
          });
          reject(error);
        },
      });
    });
  }

  ngOnInit() {
    
    this.getCompanyIdByUuid()
      .then(() => {
        this.loadTemplates();
        // Load company types after company data is loaded
        this.getAllActiveCompanyTypes();
        
        // Additional fallback to ensure pre-selection works
        setTimeout(() => {
          this.setPreselectedCompanyType();
        }, 500);
      })
      .catch((error) => {
        console.error("Error loading company data:", error);
        this.loadTemplates(); // Still load templates, but without saved template
        this.getAllActiveCompanyTypes(); // Still load company types
        
        // Fallback for error case
        setTimeout(() => {
          this.setPreselectedCompanyType();
        }, 500);
      });

    this.getAllActiveVatList();

    this.layoutVersion = localStorage.getItem("layout_version") || "light-only";
    localStorage.setItem("layout_version", this.layoutVersion);
    document.body.classList.add(
      this.layoutVersion === "dark-only" ? "dark-only" : "light-only"
    );

    this.userRegistId = JSON.parse(localStorage.getItem("user_id"));
    this.merchantId = JSON.parse(localStorage.getItem("merchant_id"));
    this.user_type = JSON.parse(localStorage.getItem("user_type"));
  }
  selectedTemplate: any = null; // Store selected template details

  loadTemplates(): void {
    this.service.getTemplatesSelect().subscribe(
      (data: any) => {
        // Debug API response
  
        if (Array.isArray(data) && data.length > 0) {
          this.templates = data;
  
          // Get the saved template ID from the form
          let savedTemplateId =
            this.updateCompanyInfo.get("template_id")?.value ||
            this.updateCompanyInfoByAdmin.get("template_id")?.value;
  
          // Debugging
  
          if (savedTemplateId) {
            savedTemplateId = Number(savedTemplateId); // Convert to number for consistency
  
            // Check if this ID exists in the templates array
            const existsInTemplates = this.templates.some(
              (template) => template.id === savedTemplateId
            );
            if (existsInTemplates) {
              this.selectedTemplate = this.templates.find(
                (template) => template.id === savedTemplateId
              );
            } else {
              console.warn(
                `Saved Template ID (${savedTemplateId}) not found in API response. Using first template.`
              );
              this.selectedTemplate = this.templates[0];
            }
          } else {
            console.warn("No saved template found. Using first template.");
            this.selectedTemplate = this.templates[0];
          }
  
          // Update form controls with the selected template
          if (this.selectedTemplate) {
            this.updateCompanyInfo.patchValue({
              template_id: this.selectedTemplate.id,
              template_url: this.selectedTemplate.template_url,
            });
            this.updateCompanyInfoByAdmin.patchValue({
              template_id: this.selectedTemplate.id,
              template_url: this.selectedTemplate.template_url,
            });
          }
  
          // Debugging
        }
      },
      (error) => {
        console.error("Error fetching templates:", error);
      }
    );
  }

  onTemplateChange(selectedTemplateId: string) {
    if (!selectedTemplateId) {
      console.error("Template ID is missing or invalid:", selectedTemplateId);
      return;
    }
  
    const templateIdNumber = Number(selectedTemplateId); // Convert to number
    // Debugging
  
    // Find the selected template object from the array
    const foundTemplate = this.templates.find(
      (template) => template.id === templateIdNumber
    );
  
    if (!foundTemplate) {
      console.error("No matching template found for ID:", templateIdNumber);
      return;
    }
  
    this.selectedTemplate = foundTemplate; // Store the selected template object
  
    // Debugging
  
    // Update form controls
    this.updateCompanyInfo.patchValue({ template_id: templateIdNumber });
    this.updateCompanyInfoByAdmin.patchValue({ template_id: templateIdNumber });
  
    }
  getAllActiveVatList() {
    this.spinner.show();
    this.service.getAllActiveVatList().subscribe({
      next: (res) => {
        this.vatInfoData = res;
        this.spinner.hide();
      },
      error: (error) => {
        this.spinner.hide();
      },
    });
  }

  getAllActiveCompanyTypes() {
    this.companyTypeLoading = true;
    this.spinner.show();
    this.service.getAllActiveCompanyTypes().subscribe({
      next: (res) => {
        // Debug log
        this.companyTypeData = res || [];
        this.companyTypeLoading = false;
        this.spinner.hide();
        
        // Set the pre-selected value after company type data is loaded
        this.setPreselectedCompanyType();
        
        // Force change detection after data is loaded
        this.cdRef.detectChanges();
      },
      error: (error) => {
        console.error('Error loading company types:', error); // Debug log
        this.companyTypeData = [];
        this.companyTypeLoading = false;
        this.spinner.hide();
      },
    });
  }

  setValue(userId: number) {
    const userToUpdate = this.companyInfoData;
    if (userToUpdate) {
      this.uploadImage?.get("id")?.setValue(userToUpdate.company_id);
      this.uploadImage?.get("file")?.setValue(this.currentImageUrl);
    }
  }

  executeFunctions(userId: number, uploadData: any) {
    this.getId(userId);
    this.openVerticallyCentered2(uploadData, userId);
    this.setValue(userId);
    const selectedProfile = this.companyInfoData;
    if (selectedProfile) {
      this.currentImageUrl = selectedProfile?.logo_url;
    }
  }

  executeFunctionsSignatureModal(userId: number, uploadSignature: any) {
    this.getId(userId);
    this.openVerticallyCentered2(uploadSignature, userId);
    this.setValue(userId);
    const selectedProfile = this.companyInfoData;
    if (selectedProfile) {
      this.currentImageUrl = selectedProfile?.seal_url;
    }
  }

  uploadFile() {
    const formData = new FormData();
    if (this.file != null) {
      formData.append("file", this.file, this.file.name);
    }
    this.spinner.show();
    this.service.uploadCompanyImage(this.id, formData).subscribe({
      next: (response) => {
        Swal.fire({
          icon: "success",
          title:
            this.curentLang === "ar"
              ? response.messageAr
              : this.curentLang === "en"
              ? response.messageEn
              : response.messageHe,
        });
        this.modalService.dismissAll();
        this.getCompanyInfoById();
        this.uploadImage.reset();
        this.spinner.hide();
        if (response.status == 400) {
          Swal.fire(response.message);
          this.spinner.hide();
        }
      },
      error: (error) => {
        Swal.fire(error.message);
        this.spinner.hide();
      },
    });
  }
  uploadSeal() {
    const formData = new FormData();
    if (this.file != null) {
      formData.append("file", this.file, this.file.name);
    }
    this.spinner.show();
    this.service.uploadCompanySeal(this.id, formData).subscribe({
      next: (response) => {
        Swal.fire({
          icon: "success",
          title:
            this.curentLang === "ar"
              ? response.messageAr
              : this.curentLang === "en"
              ? response.messageEn
              : response.messageHe,
        });
        this.modalService.dismissAll();
        this.getCompanyInfoById();
        this.uploadImage.reset();
        this.spinner.hide();
        if (response.status == 400) {
          Swal.fire(response.message);
          this.spinner.hide();
        }
      },
      error: (error) => {
        Swal.fire(error.message);
        this.spinner.hide();
      },
    });
  }

  onFileChanged(event: any) {
    this.file = event.target.files[0];
    if (event.target.files && event.target.files[0]) {
      var reader = new FileReader();
      reader.onload = (event: any) => {
        this.currentImageUrl = event.target.result;
        this.cdRef.detectChanges();
      };
      reader.readAsDataURL(event.target.files[0]);
    }
  }

  openVerticallyCentered2(uploadData: any, userId: any) {
    this.modalService.open(uploadData, { centered: true });
    userId = this.id;
  }

  getId(id: number) {
    this.id = id;
  }

  /** Current user ID from localStorage (used for updated_by). */
  private getCurrentUserId(): number {
    const raw = localStorage.getItem("user_id");
    if (raw == null) return 0;
    try {
      const parsed = JSON.parse(raw);
      return Number(parsed) || 0;
    } catch {
      return Number(raw) || 0;
    }
  }

  updateCompanyById(): void {
    if (!this.updateCompanyInfo.valid) {
      this.validateMerchant = true;
      this.updateCompanyInfo.markAllAsTouched();
      return;
    }
    this.validateMerchant = false;

    let model = {
      company_name_en: this.updateCompanyInfo.value.company_name_en,
      company_name_ar: this.updateCompanyInfo.value.company_name_ar,
      company_name_he: this.updateCompanyInfo.value.company_name_he,
      company_Building_number: this.updateCompanyInfo.value.company_Building_number,
      company_address_str: this.updateCompanyInfo.value.company_address_str,
      company_address_city: this.updateCompanyInfo.value.company_address_city,
      company_address_str_ar: this.updateCompanyInfo.value.company_address_str_ar,
      company_address_str_en: this.updateCompanyInfo.value.company_address_str_en,
      company_address_city_ar: this.updateCompanyInfo.value.company_address_city_ar,
      company_address_city_en: this.updateCompanyInfo.value.company_address_city_en,
      company_address_zip_code: this.updateCompanyInfo.value.company_address_zip_code,
      company_phone: this.updateCompanyInfo.value.company_phone,
      templateId: this.updateCompanyInfo.value.template_id, // Ensure this is included
      company_type_id: Number(this.updateCompanyInfo.value.company_type_id),

      // ✅ Convert new lines to <br> before sending to API
      left_note: this.updateCompanyInfo.value.left_note 
        ? this.updateCompanyInfo.value.left_note.replace(/\n/g, '<br>') 
        : '',

      right_note: this.updateCompanyInfo.value.right_note 
        ? this.updateCompanyInfo.value.right_note.replace(/\n/g, '<br>') 
        : '',

      updated_by: this.getCurrentUserId(),
    };
  
    // Debugging log
  
    this.spinner.show();
    this.service.updateCompanyById(this.id, model).subscribe(
      (res) => {
        // Debugging log
  
        if (res.status === 200) {
          Swal.fire({
            icon: "success",
            title:
              this.curentLang === "ar"
                ? res.messageAr
                : this.curentLang === "en"
                ? res.messageEn
                : res.messageHe,
          });
          this.modalService.dismissAll();
          this.getCompanyInfoById();
        } else {
          this.handleErrorResponse(res);
        }
        this.spinner.hide();
      },
      (error) => {
        console.error("API Error:", error);
        Swal.fire({
          icon: "error",
          title: "An error occurred while updating the company.",
        });
        this.spinner.hide();
      }
    );
  }

  updateCompanyByAdminByCompanyId() {
    const lnCtl = this.updateCompanyInfo.get("left_note");
    const rnCtl = this.updateCompanyInfo.get("right_note");
    if (lnCtl?.hasError("maxlength") || rnCtl?.hasError("maxlength")) {
      Swal.fire({
        icon: "warning",
        title:
          this.curentLang === "ar"
            ? "طول الملاحظات"
            : this.curentLang === "en"
            ? "Notes too long"
            : "הערות ארוכות מדי",
        html:
          '<p style="margin:0;text-align:' +
          (this.curentLang === "ar" ? "right" : "left") +
          '">' +
          (this.curentLang === "ar"
            ? "يجب ألا تتجاوز ملاحظات الفاتورة (يمين أو يسار) 200 حرفاً لكل منها."
            : this.curentLang === "en"
            ? "Right and left invoice notes must be at most 200 characters each."
            : "הערות החשבונית (ימין ושמאל) חייבות להיות עד 200 תווים כל אחת.") +
          "</p>",
      });
      lnCtl?.markAsTouched();
      rnCtl?.markAsTouched();
      this.updateCompanyInfoByAdmin.markAllAsTouched();
      this.validate = !this.validate;
      return;
    }

    if (
      !this.updateCompanyInfoByAdmin.value.company_name_he ||
      !this.updateCompanyInfoByAdmin.value.company_address_str ||
      !this.updateCompanyInfoByAdmin.value.company_Building_number ||
      !this.updateCompanyInfoByAdmin.value.company_address_city ||
      !this.updateCompanyInfoByAdmin.value.company_address_str_ar ||
      !this.updateCompanyInfoByAdmin.value.company_address_str_en ||
      !this.updateCompanyInfoByAdmin.value.company_address_city_ar ||
      !this.updateCompanyInfoByAdmin.value.company_address_city_en ||
      !this.updateCompanyInfoByAdmin.value.company_Building_number ||
      !this.updateCompanyInfoByAdmin.value.company_address_zip_code ||
      !this.updateCompanyInfoByAdmin.value.commercial_register ||
      !this.updateCompanyInfoByAdmin.value.tax_register
    ) {
      Swal.fire({
        icon: "warning",
        title:
          this.curentLang === "ar"
            ? "يرجى ملء الحقول المطلوبة"
            : this.curentLang === "en"
            ? "Please fill out the required fields"
            : "אנא מלא את השדות הנדרשים",
      });

      this.updateCompanyInfoByAdmin.markAllAsTouched();
      this.validate = !this.validate;
      return;
    }

    const companyNameHe = this.updateCompanyInfoByAdmin.value.company_name_he;
    this.updateCompanyInfoByAdmin.patchValue({
      company_name_ar: companyNameHe,
      company_name_en: companyNameHe,
    });

    let model = {
      tax_register: this.updateCompanyInfoByAdmin.value.tax_register,
      commercial_register:
        this.updateCompanyInfoByAdmin.value.commercial_register,
      company_name_en: this.updateCompanyInfoByAdmin.value.company_name_en,
      company_name_ar: this.updateCompanyInfoByAdmin.value.company_name_ar,
      company_name_he: this.updateCompanyInfoByAdmin.value.company_name_he,
      company_phone: this.updateCompanyInfoByAdmin.value.company_phone,
      company_address_str:
        this.updateCompanyInfoByAdmin.value.company_address_str,
      company_address_str_ar:
        this.updateCompanyInfoByAdmin.value.company_address_str_ar,
      company_address_str_en:
        this.updateCompanyInfoByAdmin.value.company_address_str_en,
      company_Building_number:
        this.updateCompanyInfoByAdmin.value.company_Building_number,
      company_address_city:
        this.updateCompanyInfoByAdmin.value.company_address_city,
      company_address_city_ar:
        this.updateCompanyInfoByAdmin.value.company_address_city_ar,
      company_address_city_en:
        this.updateCompanyInfoByAdmin.value.company_address_city_en,
      company_address_zip_code:
        this.updateCompanyInfoByAdmin.value.company_address_zip_code,
      templateId: this.updateCompanyInfoByAdmin.value.template_id, // Ensure this is included
      company_type_id: Number(this.updateCompanyInfoByAdmin.value.company_type_id),
      left_note: this.updateCompanyInfo.value.left_note
        ? String(this.updateCompanyInfo.value.left_note).replace(/\n/g, "<br>")
        : "",
      right_note: this.updateCompanyInfo.value.right_note
        ? String(this.updateCompanyInfo.value.right_note).replace(/\n/g, "<br>")
        : "",
      updated_by: this.getCurrentUserId(),
    };

    // Debugging log

    this.spinner.show();
    this.service.updateCompanyByAdminByCompanyId(this.id, model).subscribe(
      (res) => {
        // Debugging log

        if (res.status === 200) {
          Swal.fire({
            icon: "success",
            title:
              this.curentLang === "ar"
                ? res.messageAr
                : this.curentLang === "en"
                ? res.messageEn
                : res.messageHe,
          });
          this.modalService.dismissAll();
          this.getCompanyInfoById();
        } else {
          this.handleErrorResponse(res);
        }
        this.spinner.hide();
      },
      (error) => {
        console.error("API Error (Admin):", error);
        Swal.fire({
          icon: "error",
          title: "An error occurred while updating the company.",
        });
        this.spinner.hide();
      }
    );
  }

  // Common function to handle error responses
  handleErrorResponse(res: any) {
    let errorMessage =
      this.curentLang === "ar"
        ? "حدث خطأ غير معروف"
        : this.curentLang === "en"
        ? "An unknown error occurred"
        : "אירעה שגיאה לא ידועה";
    if (res.messageAr || res.messageEn || res.messageHe) {
      errorMessage =
        this.curentLang === "ar"
          ? res.messageAr
          : this.curentLang === "en"
          ? res.messageEn
          : res.messageHe;
    }

    Swal.fire({ icon: "error", title: errorMessage });
  }

  isNumber(event: KeyboardEvent): boolean {
    const charCode = event.which ? event.which : event.keyCode;
    if (charCode > 31 && (charCode < 48 || charCode > 57)) {
      event.preventDefault();
      return false;
    }
    return true;
  }

  onCompanyTypeChange(selectedValue: any) {
    // Update both forms with the selected value
    this.updateCompanyInfo.patchValue({ company_type_id: selectedValue });
    this.updateCompanyInfoByAdmin.patchValue({ company_type_id: selectedValue });
    
    // Force change detection
    this.cdRef.detectChanges();
  }

  // Removed forceUpdateRadioButtons() method to prevent flashing

  getSelectedCompanyTypeName(): string {
    const selectedId = this.updateCompanyInfo.get('company_type_id')?.value || this.updateCompanyInfoByAdmin.get('company_type_id')?.value;
    if (selectedId && this.companyTypeData.length > 0) {
      const selectedType = this.companyTypeData.find((item: any) => item.company_type_id === selectedId);
      if (selectedType) {
        return this.curentLang === 'en' ? selectedType.type_name_en : 
               (this.curentLang === 'ar' ? selectedType.type_name_ar : selectedType.type_name_he);
      }
    }
    return '';
  }

  setPreselectedCompanyType() {
    // Get the company type ID from the loaded company data
    const companyTypeId = this.companyInfoData?.company_type_id;
    
    if (companyTypeId && this.companyTypeData.length > 0) {
      // Check if the company type exists in the loaded data
      const companyTypeExists = this.companyTypeData.some((item: any) => item.company_type_id === companyTypeId);
      
      if (companyTypeExists) {
        // Set the value in both forms - this will automatically update the radio buttons
        this.updateCompanyInfo.patchValue({ company_type_id: companyTypeId });
        this.updateCompanyInfoByAdmin.patchValue({ company_type_id: companyTypeId });
        
        } else {
        console.warn('Company type ID not found in available options:', companyTypeId);
      }
    } else if (companyTypeId && this.companyTypeData.length === 0) {
      // Retry after a short delay
      setTimeout(() => {
        this.setPreselectedCompanyType();
      }, 200);
    } else {
      }
  }
}
